export default function formatCurrency(amount) {
  return Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
   amount,
 );
}